export const VKONTACTE = {
  api: 'http://vk.com/share.php',
  mod: 'vk',
  title: 'ВКонтакте',
  keys: {
    url: 'url',
    title: 'title',
    image: 'image'
  }
};
export const FACEBOOK = {
  api: 'http://www.facebook.com/sharer.php',
  mod: 'fb',
  title: 'Facebook',
  keys: {
    url: 'u',
  }
};
export const ODNOKLASSNIKI = {
  api: 'https://connect.ok.ru/offer',
  mod: 'ok',
  title: 'Одноклассники',
  keys: {
    url: 'url',
    title: 'title',
    image: 'imageUrl',
  }
};
export const TWITTER = {
  api: 'http://twitter.com/share',
  mod: 'tw',
  title: 'Twitter',
  keys: {
    url: 'url',
    title: 'text',
  }

};
export const TELEGRAM = {
  api: 'https://telegram.me/share/url',
  mod: 'tm',
  title: 'Telegram',
  keys: {
    url: 'url',
    title: 'text',
  }
};
export const WHATSAPP = {
  api: 'https://api.whatsapp.com/send',
  mod: 'wh',
  title: 'WhatsApp',
  keys: {
    messangerText: 'text',
  }
};
export const VIBER = {
  api: 'viber://forward',
  mod: 'vb',
  title: 'Viber',
  keys: {
    messangerText: 'text',
  }
};

export const SHARE_DEFAULT = [
  ['vk', VKONTACTE],
  ['fb', FACEBOOK],
  ['ok', ODNOKLASSNIKI],
  ['twitter', TWITTER],
  ['telegram', TELEGRAM],
  ['whatsapp', WHATSAPP],
  ['viber', VIBER]
];



// WEBPACK FOOTER //
// ./components/share/settings/constants.js